import * as React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import awardsImg from "../../../static/2023";

export default function Event2023() {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photosToShow = isMd ? awardsImg : awardsImg.slice(0, awardsImg.length);

  return (
    <Box marginTop={{ xs: "5%", sm: "2%" }}>
      <ImageList sx={{ width: 1200, height: 675 }} cols={8} rowHeight={164}>
        {photosToShow.map((item) => (
          <ImageListItem key={item.imgPath}>
            <img
              src={`${item.imgPath}?w=164&h=164&fit=crop&auto=format`}
              srcSet={`${item.imgPath}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
              alt={"2022 ACAwards"}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}
